const ShowProductSearchDebugInfoCookieKey = "_ali_show-product-search-debug-info";

export function useShowProductSearchDebugInfo() {
	var cookie = useCookie<boolean>(ShowProductSearchDebugInfoCookieKey, {
		default: () => false,
	});
	return cookie;
}
